import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Input, Radio, TextArea, Grid } from "semantic-ui-react";
import { numRegex } from "../../utils/regex";
import { addPlans } from "../../store/actions/athleteActions";
const EditCard = ({ callClose, plan }) => {
  const data = {};
  const [OTP, setOTP] = useState(false);
  const [trans, setTrans] = useState(false);
  const [dollars, setDollars] = useState(null);
  const [dollarsEr, setDollarsEr] = useState(false);
  const [monthsEr, setMonthsEr] = useState(false);
  const [months, setMonths] = useState(null);
  const [desc, setDesc] = useState(null);
  const [error, setError] = useState(null);
  const [classYear, setClassYear] = useState(null);
  const [classEr, setClassEr] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setDollars(plan.amount * 0.01);
    !plan.otp && setMonths(plan.months);
    setDesc(plan.description);
    setTrans(plan.collegeTransfer);
    setOTP(plan.otp);
    setClassYear(plan.classYear);
  }, [
    plan.amount,
    plan.months,
    plan.description,
    plan.collegeTransfer,
    plan.otp,
    plan.classYear,
  ]);

  const handleOnChange = (name, value) => {
    switch (name) {
      case "amount":
        if (numRegex.test(value)) {
          setDollars(value);
          setDollarsEr(false);
          setError(null);
        } else {
          setError("Only numbers");
          setDollarsEr(true);
        }
        break;
      case "months":
        if (numRegex.test(value)) {
          setMonths(value);
          setMonthsEr(false);
          setError(null);
        } else {
          setError("Only numbers");
          setMonthsEr(true);
        }
        break;
      case "class":
        if (!isNaN(value) && value.length === 4) {
          setClassYear(value);
          setClassEr(false);
          setError(null);
        } else {
          setError("It should be year");
          setClassEr(true);
        }
        break;
      default: {
      }
    }
  };

  const handleDataSet = () => {
    if (error || dollarsEr) {
      setError("All fields are required");
    }
    if (
      (!OTP && !months && !classYear) ||
      (!OTP && !months && classYear) ||
      (!OTP && months && !classYear) ||
      // if OTP both should be empty
      (OTP && months && classYear) ||
      (OTP && !months && classYear) ||
      (OTP && months && !classYear)
    ) {
      setError("Not valid");
    } else if (!OTP && months && classYear) {
      data.months = Number(months);
      data.classYear = Number(classYear);
      handleSubmit(data);
    } else if (OTP && !months && !classYear) {
      data.months = null;
      data.classYear = null;
      handleSubmit(data);
    }
  };

  const handleSubmit = (data) => {
    if (dollars && desc && !error && !dollarsEr) {
      data.planId = plan.planId;
      data.amount = Number(dollars) * 100;
      data.description = desc;
      data.otp = OTP;
      data.collegeTransfer = trans;
      data.show = false;
      dispatch(addPlans(data));
      setOTP(false);
      setTrans(false);
      setDollars(null);
      setDollarsEr(false);
      setMonthsEr(false);
      setMonths(null);
      setDesc(null);
      setError(null);
      callClose();
    }
  };

  return (
    <div className="price-table">
      {error && <p style={{ color: "#800000" }}>{error}</p>}

      <Grid divided="vertically">
        <Grid.Row stackable="true" columns={2}>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div className="main-switch-box">
              <div>
                <Radio
                  toggle
                  label="One Time Payment"
                  name="otp"
                  checked={OTP}
                  disabled={trans}
                  onChange={(not, data) => {
                    setOTP(data.checked);
                    setError(null);
                    setMonths(null);
                    setClassYear(null);
                  }}
                />
              </div>
              <div>
                <Radio
                  toggle
                  checked={trans}
                  label="College Transfer"
                  name="clgtrans"
                  onChange={(not, data) => {
                    setTrans(data.checked);
                    setOTP(data.checked ? true : false);
                    setError(null);
                    setMonths(null);
                    setClassYear(null);
                  }}
                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div className="form-group cu-form-groups mb-0">
              <label htmlFor="email">
                Amount <span className="required">*</span>
              </label>
              <Input
                placeholder="Amount"
                name="amount"
                labelPosition="left"
                error={dollarsEr}
                onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                defaultValue={dollars}
              />
            </div>
          </Grid.Column>
          {!OTP && !trans && (
            <>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <div className="form-group cu-form-groups mb-0">
                  <label htmlFor="email">
                    Months <span className="required">*</span>
                  </label>
                  <Input
                    labelColor="aqua"
                    placeholder="6"
                    name="months"
                    error={monthsEr}
                    onChange={(e) =>
                      handleOnChange(e.target.name, e.target.value)
                    }
                    defaultValue={months}
                  />
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <div className="form-group cu-form-groups mb-0">
                  <label htmlFor="email">
                    Class Above Can Select Plan{" "}
                    <span className="required">*</span>
                  </label>
                  <Input
                    labelColor="aqua"
                    placeholder="2026"
                    defaultValue={classYear}
                    name="class"
                    error={classEr}
                    onChange={(e) =>
                      handleOnChange(e.target.name, e.target.value)
                    }
                  />
                </div>
              </Grid.Column>
            </>
          )}

          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div className="form-group cu-form-groups mb-0">
              <label htmlFor="email">
                Description <span className="required">*</span>
              </label>
              <TextArea
                className="cu-textarea with-rad"
                placeholder="Description"
                name="description"
                rows={6}
                onChange={(e) => {
                  setDesc(e.target.value);
                  setError(null);
                }}
                defaultValue={desc}
              />
            </div>
          </Grid.Column>

          <Grid.Column
            mobile={16}
            tablet={16}
            computer={16}
            className="cu-center mb-0"
          >
            <Button
              className="saveCubutton"
              content="Save"
              disabled={error ? true : false}
              circular
              color="teal"
              onClick={handleDataSet}
            />
          </Grid.Column>

          <Grid.Column mobile={16} tablet={16} computer={16}></Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default EditCard;
